module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm2.8ef22b0f8c575b8902abdb6ac8a3cb99.png";